import type { Config, ReactiveSource } from '../@types/editor'

type PlaysStore = {
  maxPlays: (config: Config) => number
  savedPlays: unknown[]
}

export const useEditorMaxPlaysToast = (
  store: PlaysStore,
  configRef: ReactiveSource<Maybe<Config>>,
  disabledRef: ReactiveSource<boolean>,
) => {
  const { addToast } = useToaster()
  const { t } = useI18n()

  watch(
    [() => toValue(disabledRef), () => store.savedPlays.length],
    ([disabled, saved], [wasDisabled, wasSaved]) => {
      const config = toValue(configRef)
      // restoring saved plays can fill the slots without the customer asking for another play
      if (!disabled || wasDisabled || saved < wasSaved || !config) return

      addToast(
        {
          headline: t('lottery.selectednumbers.toast.maxplays.headline'),
          message: t('lottery.selectednumbers.toast.maxplays.message', {
            count: store.maxPlays(config),
          }),
          tracking: {
            action: 'checkout',
            topicKey: 'max_plays_reached',
          },
        },
        'max-plays-reached',
      )
    },
  )
}
